import {
  ONE_STEM_TRANSITION_QUERY_PARAMETER,
  ONE_STEM_TRANSITION_SOURCE,
} from './one-stem-transition'

function parseLegacyHosts(value: string | undefined): string[] {
  return String(value || '')
    .split(',')
    .map((host) => host.trim().toLowerCase())
    .filter(Boolean)
}

interface LegacyAdminHostOptions {
  location?: Pick<Location, 'hostname' | 'pathname' | 'search' | 'hash' | 'replace'>
  canonicalAppUrl?: string
  legacyHosts?: string
}

export function redirectLegacyAdminHost({
  location = window.location,
  canonicalAppUrl = import.meta.env.VITE_APP_URL,
  legacyHosts = import.meta.env.VITE_LEGACY_APP_HOSTS,
}: LegacyAdminHostOptions = {}): boolean {
  if (
    !canonicalAppUrl ||
    !parseLegacyHosts(legacyHosts).includes(location.hostname.toLowerCase())
  ) {
    return false
  }

  let destination
  try {
    destination = new URL(canonicalAppUrl)
  } catch {
    return false
  }
  if (destination.hostname === location.hostname) {
    return false
  }

  destination.pathname = location.pathname
  destination.search = location.search
  destination.searchParams.set(ONE_STEM_TRANSITION_QUERY_PARAMETER, ONE_STEM_TRANSITION_SOURCE)
  destination.hash = location.hash
  location.replace(destination.toString())

  return true
}
